export default "/kiban/_next/static/images/05_2L_cupper_base-1201c4e60cbd4a2a99a4b4c0eed81469.png";